export default "//qa-static.glanacion.com/v2/ingresar-nuevo/images/error-gral.png";